import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../../Components/Layout/Header.jsx'
import { ObavijestiPoker } from '../../../Components/Layout/ObavijestiPoker.jsx'


export class PokerRoom extends React.Component {


    constructor(props) {
        super(props);
        this.state = { tabs: ['Informacije', 'Raspored', 'Rezultati'], selectedTab: null }

        this.gotoTab = this.gotoTab.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Poker uživo', 'Poker room', 'poker');
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.gotoTab('Rezultati');
    }
    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    render() {
        return <div>
            <Switch>
                <Route render={(route) =>
                    <div>
                        <Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText='Poker room' headerBackUrl={'/poker/live'}></Header>
                    </div>
                } />
            </Switch>

            <div className="white-background">
                <div className="poker-room-background">
                    <div className='poker-room-logo'></div>
                </div>

                <div className="poker-container-wider ">
                    <div className="margin-top-small padding-sides-medium-2">
                        <h3 style={{ marginTop: "-10px" }}>POKER ROOM</h3>
                            Poker uživo <b>petkom, subotom i nedjeljom </b> u našem <b>Live Poker Room-u</b> na adresi <b>Gospodska ul. 41, Stenjevec u Zagrebu</b>!
                            <br /><br />
                        Zaigrajte Poker u opuštenoj atmosferi na Cash stolovima ili sudjelujte na Poker turnirima uživo s garantiranim nagradnim fondom!<br />
                        <br />
                        <img src="https://cdn.supersport.hr/Casino/Images/PokreRoomOpeningEvent/Image28.jpg" width="100%" />


                        <br /><br /><br />
                        <h3 style={{ marginTop: "-10px" }}>KALENDAR DOGAĐAJA 2019</h3>

                    </div>
                    <table className="table-1 v2 v3  text text-1 ">
                        <thead>
                            <tr>
                                <th className="text-left text text-6">Dan</th>
                                <th className="text-left text text-6">Start</th>
                                <th className="text-left text text-6">Event</th>
                                <th className="text-left text text-6">Buy-in</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Petak, 15.02.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Subota, 16.02.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Nedjelja, 17.02.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td colSpan="5"><b>CASH GAME – CASHROLL - SUPERSPORT CLASSIC MINI 1061.78 € GTD</b></td>
                            </tr>

                            <tr className="horizontal-lines">
                                <td rowSpan="2">Petak, 22.02.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Subota, 23.02.2019</td>
                                <td>17:30h</td>
                                <td>FREEROLL 10 TKT GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">18:00h</td>
                                <td>SuperSport Classic Mini 1061.78 €</td>
                                <td>13.27+1.33 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Nedjelja, 24.02.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td colSpan="5"><b>CASH GAME – CASHROLL - SUPERSPORT CLASSIC MINI 1061.78 € GTD</b></td>
                            </tr>



                            <tr className="horizontal-lines">
                                <td rowSpan="2">Petak, 01.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Subota, 02.03.2019</td>
                                <td>17:30h</td>
                                <td>FREEROLL 10 TKT GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">18:00h</td>
                                <td>SuperSport Classic Mini 1061.78 €</td>
                                <td>13.27+1.33 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Nedjelja, 03.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td colSpan="5"><b>CASH GAME – CASHROLL - SUPERSPORT CLASSIC MINI 1061.78 € GTD</b></td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Petak, 08.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Subota, 09.03.2019</td>
                                <td>17:30h</td>
                                <td>FREEROLL 10 TKT GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">18:00h</td>
                                <td>SuperSport Classic Mini 1061.78 €</td>
                                <td>13.27+1.33 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Nedjelja, 10.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td colSpan="5"><b>CASH GAME – CASHROLL - SUPERSPORT CLASSIC 2123.56 € GTD</b></td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Petak, 15.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 € GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Subota, 16.03.2019</td>
                                <td>15:30h</td>
                                <td>FREEROLL 5 TKT GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">16:00h</td>
                                <td>SuperSport Classic 2123.56 €</td>
                                <td>30.53+2.65 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td rowSpan="2">Nedjelja, 17.03.2019</td>
                                <td>19:30h</td>
                                <td>CASHROLL 132.72 €GTD</td>
                                <td>0+0 €</td>
                            </tr>
                            <tr className="horizontal-lines">
                                <td className="no-padding">20:00h</td>
                                <td>CASH GAME</td>
                                <td>13.27 €</td>
                            </tr>
                        </tbody>
                    </table>


                    <br /><br /><br />
                    <div className="padding-sides-medium-2">
                        <h3 style={{ marginTop: "-10px" }}>GDJE SE NALAZIMO</h3>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2338.286869712404!2d15.886401618798786!3d45.817118429446616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4765d108a5f899c5%3A0x91e62e6aa2e71461!2sGospodska+ul.+41%2C+10000%2C+Zagreb!5e0!3m2!1sen!2shr!4v1527239252882" width="100%" height="450" frameBorder="0" style={{ border: "0" }} allowFullScreen></iframe>

                    </div>

                    <br />




                </div>
                <ObavijestiPoker {...this.props}></ObavijestiPoker>
            </div>
        </div>


    }
};
